import Resource from 'Resources/Resource';

/**
 * The Looker SSO handshake. `/function/externalSSO/looker/:type/:id` is a `type: 'raw'` route
 * whose envelope carries the signed embed URL as a bare string in `data`, so this goes
 * straight to `_getRequest` rather than through `find()`/`get()` — the same shape as
 * `WhatIsMyIp.ts`.
 */
class LookerSSO extends Resource {
	constructor() {
		super('function/externalSSO/looker');
	}

	/**
	 * `useNext` picks Looker's newer viewer and is passed through unchanged — the API reads it
	 * as `req.query.useNext === 'true'`, so a falsy value is a real value to send.
	 *
	 * `refresh` is how often Looker should re-run the dashboard's queries server-side, as a
	 * Looker duration ('10s'). Only the Report Center TV player sets it: an embed left up on a
	 * wall would otherwise show whatever was cached when it was signed.
	 */
	getSignedUrl(type: string, id: string, useNext: boolean | string, refresh?: string): Promise<string> {
		return this._getRequest(`${type}/${id}`, {
			methodName: 'getSignedUrl',
			params: { useNext, refresh }
		}).then((res: { data: { data: string } }) => res.data.data);
	}
}

const resource = new LookerSSO();

export default resource;
